import React from 'react';

// styles
import useStyles from '../../../assets/styles/jss/pages/exploreHome/bannerBySeasonStyle'

//material
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

//assets/images
import { Hidden, useMediaQuery } from '@material-ui/core';
import ResponsiveContainer from '../../../shared/components/ResponsiveContainer/ResponsiveContainer';
import {PROMOTION} from '../../../shared/constants/promotional-banner';
// shared constants
import {bannersPromotion} from '../../../shared/constants/bannersPromotion';

const BannerBySeasonVideo = ({type}) => {
    const promotion = bannersPromotion[type];
    const classes = useStyles();
    const isXs = useMediaQuery(theme => theme.breakpoints.down('xs'));
    const src = isXs ? bannersPromotion[type]?.videoXs : bannersPromotion[type]?.video;
    const poster = isXs ? bannersPromotion[type]?.imgXs : bannersPromotion[type]?.img;

    return (
        <Box id="banner-video-root" className={classes.root} sx={{height:{xs: '609px !important',sm: '348px !important', md: '650px !important'}}}>

            <Hidden xsDown>
                <video className={classes.bgVideo} autoPlay loop muted poster={poster}>
                    <source src={src} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            </Hidden>
            <Hidden smUp>
                {/* <Box className={classes.bgImageVideo}/> */}
                <video className={classes.bgVideo} autoPlay loop muted poster={poster}>
                    <source src={src} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            </Hidden>

            <ResponsiveContainer className={classes.responsiveContainer}>
                <Box className={classes.videoContent}>
                    <Box textAlign='inherit' display='flex' flexDirection='column' sx={{gridGap:{xs: '10px',sm: '16px', md: '32px'}}} width="540px" className={classes.videoContentTitle}>
                        {promotion.desc.texts.map((text, index) => (
                            <Typography key={index} variant={text.style.variant} className={`text-${text.style.color}`}>
                                {text.text}
                            </Typography>
                        ))}
                    </Box>

                    <Box className={classes.actions}>
                        <Button variant='contained' size='large' style={{minWidth: 200}} href={PROMOTION.URL_UTM}>Empieza ya</Button>
                    </Box>
                </Box>
            </ResponsiveContainer>
        </Box>
    );
};

export default BannerBySeasonVideo;
